export default __webpack_public_path__ + "static/media/selected-item-mark.fca78089.svg";